import { connect } from 'react-redux';
import { showReportModal } from '../../../../Moderation/redux/actions';
import { getIsCurrentUserAuthorOf } from '../../../../redux/deviations/selectors';
import { shareDeviationToPost } from '../../../../redux/deviations/actionCreators';
const mapStateToProps = (state, ownProps)=>({
        isOwner: getIsCurrentUserAuthorOf(state, ownProps.deviation)
    });
const mapDispatchToProps = {
    showReportModal,
    shareDeviationToPost
};
export default connect(mapStateToProps, mapDispatchToProps);
